import type { UpperLowerTransformer } from "@/types/workspace";
import { Text } from "@mantine/core";
import { TransformerBase } from "./TransformerBase";

export function TransformerUpperLower({
  data: _data,
  warning,
  error,
  onUpdate: _onUpdate,
}: {
  data: UpperLowerTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: UpperLowerTransformer) => void;
}) {
  return (
    <TransformerBase warning={warning} error={error}>
      <Text fz={14} lh={1.4} fw={500} c="gray.9">
        Not implemented
      </Text>
    </TransformerBase>
  );
}
